import React from 'react';
import SignatureCanvas from "react-signature-canvas";
import { Button, Form } from "antd";
import { withNamespaces } from 'react-i18next';

class SignatureTrimmed extends React.Component {
  render() {
    return (
      <div className='signature-canvas-form-item'>
        <Form.Item>
          <h5>{this.props.label}</h5>
          <div className='signature-wrap'>
            <div className='signature-canvas-wrap'>
              {this.props.form.getFieldDecorator(this.props.fieldName, { initialValue: this.props.fromDataURL, rules: [{ required: !this.props.optional, message: 'Required' }] })(
                <SignatureCanvas clearOnResize={false} penColor='black' canvasProps={{width: 310, height: 150, className: 'sig-canvas'}}
                                 ref={(ref) => { this.sigPad = ref }}
                                 onEnd={() => { this.props.form.setFieldsValue({ [this.props.fieldName]: this.sigPad.getTrimmedCanvas().toDataURL('image/png') }) }}
                />
              )}
            </div>
            <Button type="danger" htmlType='button' onClick={() => { this.sigPad.clear(); this.props.form.setFieldsValue({ [this.props.fieldName]: null }) }}>{this.props.i18n.t('Clear')}</Button>
          </div>
        </Form.Item>
      </div>
    );
  }
}

export default withNamespaces()(SignatureTrimmed);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/SignatureTrimmed.js